import { Loader } from '@seen/react'
import { type JSX, lazy, Suspense } from 'react'

// Admin-only route (/care-teams), reached by explicit navigation. App.tsx's
// <Outlet /> already supplies Suspense + an ErrorBoundary; the local Suspense
// keeps this safe if it is ever mounted somewhere without one.
const CareTeamsPageImpl = lazy(() =>
  import('#src/pages/care-teams/CareTeamsPageImpl.tsx').then((m) => ({
    default: m.CareTeamsPageImpl,
  }))
)

export function CareTeamsPage(): JSX.Element {
  return (
    <Suspense fallback={<Loader />}>
      <CareTeamsPageImpl />
    </Suspense>
  )
}
